import axios from 'axios'
import storageUtil from '@/helpers/storage'
import appConfig from '@/config/appConfig'
import { store } from '@/store/store'

const service = axios.create({
  baseURL: appConfig.urlApi,
  timeout: 0
})

// Request intercepter
service.interceptors.request.use(
  config => {
    const token = storageUtil.getKey('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}` // Set JWT token
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response pre-processing
service.interceptors.response.use(
  response => {
    if (response.headers.authorization) {
      storageUtil.setKey('auth_token', response.headers.authorization)
      response.data.token = response.headers.authorization
    }
    return response.data
  },
  error => {
    let errorData = error.response && error.response.data ? error.response.data : {}
    errorData = errorData.error ? errorData.error : errorData

    let responseData = {}

    switch (error.response.status) {
      case 401:
        store.commit('logoutUser')
        responseData = {
          type: error.response.status,
          message: errorData.message
        }
        break
      case 422:
        responseData = {
          type: error.response.status,
          message: errorData.message,
          fields: errorData.errors
        }
        break
      case 404:
        responseData = {
          type: error.response.status,
          message: errorData.message
        }
        break
      default:
        responseData = {
          type: error.response.status,
          message: errorData.message,
          data: errorData.data
        }
    }
    return Promise.reject(responseData)
  }
)

export default service
